import React from "react";
import { Link } from "react-router-dom";
import Logo from "../assets/logo/logo.svg"; // Assuming it's an SVG file
import { BsTwitter, BsFacebook, BsInstagram, BsLinkedin } from "react-icons/bs";

const Footer = () => {
  return (
    <footer
      id="contact"
      className="bg-[#BDE9FB] text-[#281a39] pt-32 md:pt-52 lg:pt-64 font-semibold"
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8 lg:gap-12 relative">
        {/* Logo Positioning */}
        <div className="absolute -top-20 md:-top-24 lg:-top-32 left-4 md:left-8">
          <img
            src={Logo}
            alt="Lightning Technologies Logo"
            className="w-48 md:w-56 lg:w-64 transition-all duration-300 text-[#00455e]" // Applied custom color
          />
        </div>

        {/* Contact Us Column */}
        <div className="p-4 md:p-6 space-y-4 md:space-y-6">
          <h3 className="text-lg md:text-xl lg:text-2xl font-bold">
            Contact Us
          </h3>
          <div className="space-y-3 md:space-y-4 text-sm md:text-base">
            <p>
              Sales:{" "}
              <Link
                to="mailto:sales@lightningtechnologies.net"
                className="underline break-words"
              >
                sales@lightningtechnologies.net
              </Link>
            </p>
            <p>
              Customer Care:{" "}
              <Link to="mailto:care@lightningtechnologies.net" className="underline">
                care@lightningtechnologies.net
              </Link>
            </p>
            <p>
              General Inquiries:{" "}
              <Link to="mailto:info@lightningtechnologies.net" className="underline">
                info@lightningtechnologies.net
              </Link>
            </p>
            <p>Pune, Maharashtra, India</p>
          </div>
        </div>

        {/* Quick Links Column */}
        <div className="p-4 md:p-6 space-y-4 md:space-y-6">
          <h3 className="text-lg md:text-xl lg:text-2xl font-bold">
            Quick Links
          </h3>
          <ul className="space-y-3 md:space-y-4 text-sm md:text-base">
            <li>
              <Link
                to="/terms-conditions"
                className="hover:text-[#281a39] block w-fit hover:underline"
              >
                Terms & Conditions
              </Link>
            </li>
            <li>
              <Link
                to="/privacy-policy"
                className="hover:text-[#281a39] block w-fit hover:underline"
              >
                Privacy Policy
              </Link>
            </li>
          </ul>
        </div>

        {/* Stay Connected Column */}
        <div className="p-4 md:p-6 space-y-4 md:space-y-6">
          <h3 className="text-lg md:text-xl lg:text-2xl font-bold">
            Stay Connected
          </h3>
          <div className="space-y-4 text-sm md:text-base">
            <p>Subscribe to receive the latest updates and news.</p>
            <input
              type="email"
              placeholder="Email*"
              className="w-full p-2 md:p-3 border border-gray-300 rounded-md text-sm md:text-base"
            />
            <div className="flex items-start space-x-2">
              <input type="checkbox" id="subscribe" className="mt-1" />
              <label htmlFor="subscribe" className="text-xs md:text-sm">
                Yes, subscribe me to your newsletter.
              </label>
            </div>
            <button className="w-full md:w-[200px] bg-[#281a39] text-white px-4 py-2 md:px-8 md:py-3 rounded-md hover:bg-[#1d1137] text-sm md:text-base">
              Subscribe
            </button>
          </div>
        </div>

        {/* Social Media Column */}
        <div className="p-4 md:p-6 space-y-4 md:space-y-6">
          <h3 className="text-lg md:text-xl lg:text-2xl font-bold">
            Follow Us
          </h3>
          <ul className="space-y-3 md:space-y-4 text-sm md:text-base">
            <li className="flex items-center space-x-2">
              <BsLinkedin className="text-[#0e76a8]" />
              <Link
                to="https://www.linkedin.com/company/lightning-tech"
                className="hover:text-[#281a39] block w-fit"
              >
                LinkedIn
              </Link>
            </li>
            <li className="flex items-center space-x-2">
              <BsTwitter className="text-[#1da1f2]" />
              <Link
                to="https://x.com/lightningpune"
                className="hover:text-[#281a39] block w-fit"
              >
                Twitter
              </Link>
            </li>
            <li className="flex items-center space-x-2">
              <BsFacebook className="text-[#1877f2]" />
              <Link
                to="https://www.facebook.com/people/Lightning-Technologies/61570652684534/"
                className="hover:text-[#281a39] block w-fit"
              >
                Facebook
              </Link>
            </li>
            <li className="flex items-center space-x-2">
              <BsInstagram className="text-[#e4405f]" />
              <Link
                to="https://www.instagram.com/lightningtechnologiespune/"
                className="hover:text-[#281a39] block w-fit"
              >
                Instagram
              </Link>
            </li>
          </ul>
        </div>
      </div>

      {/* Footer Bottom - Moved outside the container div */}
      <div className="w-full bg-[#281a39] text-white mt-12 md:mt-16">
        <p className="text-xs md:text-sm py-4 text-center">
          © 2024 Lightning Technologies. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
